import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

interface DashboardSectionProps {
  title: string;
  icon?: LucideIcon;
  children: ReactNode;
}

export function DashboardSection({ title, icon: Icon, children }: DashboardSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          {Icon && <Icon />}
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap items-center gap-6">{children}</div>
      </CardContent>
    </Card>
  );
}
